export async function saveBlobAsFile(
  blob: Blob,
  suggestedName: string
): Promise<boolean> {
  try {
    if ('showSaveFilePicker' in window) {
      const handle = await (window as any).showSaveFilePicker({
        suggestedName,
        types: [{ description: 'CSV file', accept: { 'text/csv': ['.csv'] } }],
      });
      const writable = await handle.createWritable();
      await writable.write(blob);
      await writable.close();
      return true;
    }

    // フォールバック（aタグダウンロード）
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = suggestedName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    return true;
  } catch (e: any) {
    if (e?.name === 'AbortError') {
      return false; // ユーザーキャンセル
    }
    throw e; // それ以外は従来通り投げる
  }
}
